// Croqui: `components/SearchInput.tsx`.

import type { InputHTMLAttributes, Ref } from 'react';
import { Input } from './input.tsx';

/**
 * Campo de busca padrão de lista. Tem a altura de todo campo do sistema (a mesma do
 * `Select` e do botão `default`, pra barra de filtros alinhar); `small` só reduz o texto.
 * `aria-label` obrigatório: o placeholder não é nome acessível (`spec/17` §7 item 12).
 */
export function SearchInput({
  label,
  small = false,
  placeholder = 'Buscar',
  className,
  ref,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'type'> & {
  label: string;
  small?: boolean;
  className?: string;
  ref?: Ref<HTMLInputElement>;
}) {
  return (
    <Input
      {...(ref === undefined ? {} : { ref })}
      {...(className === undefined ? {} : { className })}
      {...(small ? { inputClassName: 'md:text-13' } : {})}
      icon="search"
      type="search"
      aria-label={label}
      placeholder={placeholder}
      {...props}
    />
  );
}
